import { Table } from 'antd';
import type { TableProps } from 'antd';
import clsx from 'clsx';
import styles from './vs-table.module.scss';

// pagination sits before the spread: the mockup uses a "Show more" button
// rather than a numbered pager, but a caller can still opt back in.
export default function VsTable<T extends object>({ className, ...restProps }: TableProps<T>) {
  return <Table<T> className={clsx(styles.table, className)} pagination={false} {...restProps} />;
}
